export default {
  loading:{
      module : false
  },
    selectedParamTable: null,
    parameters: [],

};



// WEBPACK FOOTER //
// ./src/modules/table-parameters/state.js